import checkSegmentCookie from './checkSegmentCookie';
import { NOT_SET } from './constants';
import trackUser from './trackUser';

const trackUserOptOut = (
  email: string,
  user: any,
  setMarketing: boolean,
  source: string,
) => {
  checkSegmentCookie(user);
  const traits = { email, application: 'One Commerce', source } as any;
  if (user) {
    const { permissions } = user;
    const isLoggedInAsCeo =
      permissions &&
      permissions.oneCommerce &&
      permissions.oneCommerce.ceo &&
      permissions.oneCommerce.ceo.access;
    // traits.ceoStatus = false;
    traits.ceoId = NOT_SET;
    if (user.linkedCeoId) {
      traits.linkedCeoId = user.linkedCeoId;
    }
    if (user.firstName && user.firstName !== '') {
      traits.firstName = user.firstName;
    }
    if (user.lastName && user.lastName !== '') {
      traits.lastName = user.lastName;
    }
    if (user.phoneNumber && user.phoneNumber !== '') {
      traits.phoneNumber = user.phoneNumber;
    }
    if (user.companyName && user.companyName !== '') {
      traits.companyName = user.companyName;
    }
    if (user.zip && user.zip !== '') {
      traits.zip = user.zip;
    }
    if (isLoggedInAsCeo) {
      // traits.ceoStatus = true;
      traits.ceoId = user.userId;
    }
    if (user.grapeful_club_member) {
      traits.grapeful_club_member = user.grapeful_club_member;
    }
    if (user.grapeful_club_creation_date) {
      traits.grapeful_club_creation_date = user.grapeful_club_creation_date;
    }
    if (user.grapeful_club_current_period_start_date) {
      traits.grapeful_club_current_period_start_date =
        user.grapeful_club_current_period_start_date;
    }
    if (user.grapeful_club_renewal_date) {
      traits.grapeful_club_renewal_date = user.grapeful_club_renewal_date;
    }
    if (user.maris_picks_member) {
      traits.maris_picks_member = user.maris_picks_member;
    }
    if (user.maris_picks_creation_date) {
      traits.maris_picks_creation_date = user.maris_picks_creation_date;
    }
    if (user.maris_picks_current_period_start_date) {
      traits.maris_picks_current_period_start_date =
        user.maris_picks_current_period_start_date;
    }
    if (user.maris_picks_next_shipment_date) {
      traits.maris_picks_next_shipment_date =
        user.maris_picks_next_shipment_date;
    }
    if (user.maris_picks_shipping_address) {
      traits.maris_picks_shipping_address = user.maris_picks_shipping_address;
    }
  }

  if (setMarketing) {
    traits.acceptsMarketing = false;
  }
  const idParamsOptOut = {
    type: 'identify',
    userId: email,
    traits,
    integrations: {
      // Klaviyo is no longer being used, so a user should always opt out
      Klaviyo: { confirmOptin: false, listId: 'do not add' },
      Intercom: {
        hideDefaultLauncher: true,
        user_hash: user ? user.hashedEmail : null,
      },
    },
  };
  return trackUser(idParamsOptOut);
};

export default trackUserOptOut;
